import { string } from '@/utils/string.utils';
import { z } from 'zod';
export const agpmCreateFormSchema = z.object({
  annee: z
    .string({ required_error: "L'année est obligatoire" })
    .transform(val => Number(val))
    .refine(val => !isNaN(val), {
      message: "L'année doit être un nombre valide",
    })
    .refine(val => val >= new Date().getFullYear(), {
      message: 'L’année ne doit pas être inférieure à l’année en cours.',
    })
    .refine(val => val <= new Date().getFullYear() + 1, {
      message: 'L’année ne peut pas être supérieure à l’année prochaine.',
    }),
  nom: z.string().min(1, 'Le nom ne doit pas être vide'),
  acId: z.number({ required_error: "L'autorité contractante est obligatoire" }),
  contenu: z
    .string({ required_error: 'Le contenu est obligatoire' })
    .transform(val => string.stripHtml(val))
    .refine((val: string) => val.length > 0, {
      message: 'Le contenu ne doit pas être vide',
    }),
});
